import React from "react";
import { useHistory } from "react-router-dom";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { ChevronRight, Edit } from "@gaming/xds-react-js-icons";

import { partnerSectionLinks } from "../../../../constants";
import { useStrings } from "../../../../localization/localizationHelpers";
import * as styles from "./PartnerCardMenu.module.css";

type PartnerCardMenuProps = Readonly<{
  settingsOnly?: boolean;
  managePath: string;
  showAgreementsOption?: boolean;
  showDevReadinessGuideOption: boolean;
  showSettingsOption: boolean;
  onShowDevReadinessGuide: () => void;
}>;

export const PartnerCardMenu = ({ settingsOnly = false, managePath }: PartnerCardMenuProps) => {
  const history = useHistory();
  const [editLabel, manageLabel] = useStrings("partnerOverviewEditLabel", "manageLabel");
  const navigate = (path: string) => history.push(path);

  if (settingsOnly) {
    return (
      <button
        type="button"
        className={styles.button}
        aria-label={editLabel}
        onClick={() => navigate(partnerSectionLinks.settings.to)}
      >
        <Icon
          aria-hidden="true"
          className={styles.editIcon}
          icon={Edit}
          iconSize={IconSize.Custom}
        />
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`${styles.button} ${styles.manageButton}`}
      onClick={() => navigate(managePath)}
    >
      <span>{manageLabel}</span>
      <Icon
        aria-hidden="true"
        className={styles.chevronIcon}
        icon={ChevronRight}
        iconSize={IconSize.Custom}
      />
    </button>
  );
};
